var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.historyAiLoading,
          expression: "historyAiLoading",
        },
      ],
      staticClass: "ai-personal-infor",
    },
    [
      _vm.tipsType
        ? _c("p", { staticClass: "tips" }, [
            _vm._v(
              " AI检索已完成，如需获取该人才最新信息，请启动【AI检索】实时获取全网公开履历信息! "
            ),
          ])
        : _c("p", { staticClass: "tips" }, [
            _vm._v(
              "该人才信息尚未使用AI工具，可启动【AI检索】实时获取全网公开履历信息!"
            ),
          ]),
      _c(
        "el-button",
        {
          staticClass: "ai-search-btn",
          attrs: { disabled: _vm.isStreaming },
          on: { click: _vm.startStream },
        },
        [
          _vm._v(" AI检索生成 "),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "light",
                "popper-class": "definition-class",
                content: "利用检索增强和大模型实现专家信息的全网搜索与生成",
                placement: "top",
              },
            },
            [
              !_vm.isStreaming
                ? _c("img", {
                    staticStyle: { width: "15px" },
                    attrs: {
                      src: require("@/assets/images/talent/ai-tips.png"),
                      alt: "",
                    },
                  })
                : _c("img", {
                    staticStyle: { width: "15px" },
                    attrs: {
                      src: require("@/assets/images/talent/ai-tips2.png"),
                      alt: "",
                    },
                  }),
            ]
          ),
        ],
        1
      ),
      _vm.computedThinkingMD
        ? _c("toggle-component", { attrs: { "default-visible": true } }, [
            _c("div", {
              staticClass: "thinking-con",
              domProps: { innerHTML: _vm._s(_vm.computedThinkingMD) },
            }),
          ])
        : _vm._e(),
      _vm.historyAiThinkingData && _vm.historyAiThinkingData.length
        ? _c("toggle-component", { attrs: { "default-visible": true } }, [
            _c(
              "div",
              { staticClass: "thinking-con" },
              _vm._l(_vm.historyAiThinkingData, function (item, index) {
                return _c("p", { key: index, staticClass: "url-item" }, [
                  _c("a", { attrs: { href: item.url, target: "_blank" } }, [
                    _vm._v(_vm._s(item.url)),
                  ]),
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.lookUrlDetail(item.url, item.content)
                        },
                      },
                    },
                    [_vm._v("查看详情")]
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm.computedAnswerMD.length
        ? _c("div", {
            staticClass: "ai-infor-content",
            domProps: { innerHTML: _vm._s(_vm.computedAnswerMD) },
          })
        : _vm._e(),
      _vm.showHistoryAiInfor
        ? _c("div", {
            staticClass: "history-ai-infor",
            domProps: { innerHTML: _vm._s(_vm.computedHistoryMD) },
          })
        : _vm._e(),
      _vm.isStreaming
        ? _c("div", { staticClass: "is-streaming" }, [
            _c("img", {
              staticClass: "loading-img",
              attrs: { src: require("@/assets/images/Loading.gif"), alt: "" },
            }),
            _c("span", [_vm._v("正在联网搜索相关人物，请耐心等待...")]),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            "destroy-on-close": "",
            "lock-scroll": true,
            title: `${_vm.scholarName} - 个人资料`,
            visible: _vm.dialogUrlVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUrlVisible = $event
            },
            close: _vm.closeThinkingDialog,
          },
        },
        [
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dialogUrlLoading,
                expression: "dialogUrlLoading",
              },
            ],
            staticClass: "dialog-content",
            domProps: { innerHTML: _vm._s(_vm.dialogUrlContent) },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }